import React from 'react'
import { cond, T } from 'ramda'
import { withAuthProvider } from '../../../lib/auth'
import QuickLinks from '../QuickLinks'
import { Side } from '../Panel'
import { NewMSRCreditsBrief, NewCompactPDRBrief } from '../PDRCredits'
import { isMember, isAssociate, isStudent, hasReciprocityAttribute, hasStartedReciprocityLevels, isB25Class, hasProspectDashboard, isProspectPath } from '../../utils'
import { Loading } from '../CourseCurriculum/CourseCurriculum'
import CourseCurriculum from '../CourseCurriculum'
import PathBox from '../Prospect/PathBox'
import { withProspectDateQuery } from '../../../utils/prospect/withProspectDateQuery'

const PdrWidget = ({ collapsed }) => {
  return collapsed ? <NewCompactPDRBrief /> : <NewMSRCreditsBrief />
}

export const chooseAppropriateViewForUser = cond(
  [
    [({ loading }) => loading, () => <Loading />],
    [({ me }) => isMember(me), PdrWidget],
    [({ me }) => isB25Class(me), PdrWidget],
    [({ me }) => isAssociate(me), ({ collapsed }) => collapsed ? <div /> : <CourseCurriculum />],
    [({ me }) => isStudent(me), ({ collapsed }) => collapsed ? <div /> : <CourseCurriculum />],
    // Only show Reciprocity if they have started Z-levels, otherwise let prospects see PathBox
    [({ me }) => hasReciprocityAttribute(me) && hasStartedReciprocityLevels(me), ({ collapsed }) => collapsed ? <div /> : <CourseCurriculum />],
    [({ me, currentMember }) => hasProspectDashboard(me) || isProspectPath(currentMember), ({ collapsed }) => collapsed ? <div /> : <PathBox />],
    [T, ({ collapsed }) => <QuickLinks collapsed={collapsed} />]
  ]
)

export const MembershipSailingView = ({ me, authReady, collapsed, currentMember }) => {
  return (
    <Side basis={!collapsed && 55}>
      {chooseAppropriateViewForUser({ me, loading: !authReady, collapsed, currentMember })}
    </Side>
  )
}

export default withProspectDateQuery(withAuthProvider(MembershipSailingView))
